import React from 'react';

const FinanceManager = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between !mt-0">
        <h1 className="text-2xl font-bold text-light-darkGrey font-roboto cursor-default">
          Finance Manager
        </h1>
      </div>
      {/* Add Finance Manager page content here */}
      <p>Finance Manager page content will go here.</p>
    </div>
  );
};

export default FinanceManager;